import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { LoginPageComponent } from './login-page/login-page.component';
import { RegisterPageComponent } from './register-page/register-page.component';
import { ContactListPageComponent } from './contact-list-page/contact-list-page.component';
import { DashboardPageComponent } from './dashboard-page/dashboard-page.component';
import { TaskListPageComponent } from './task-list-page/task-list-page.component';
import { EditTaskPageComponent } from './edit-task-page/edit-task-page.component';
import { PbiConnectionPageComponent } from './pbi-connection-page/pbi-connection-page.component';
import { PasswordPageComponent } from './password-page/password-page.component';
import { ForgotPasswordPageComponent } from './forgot-password-page/forgot-password-page.component';
import { ResetPasswordPageComponent } from './reset-password-page/reset-password-page.component';
import { AccountPageComponent } from './account-page/account-page.component';

import { AuthGuard } from '../services/authentication/authguard';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { LogPageComponent } from './log-page/log-page.component';
import { AdminBillingPageComponent } from './admin-billing-page/admin-billing-page.component';
import { UserBillingPageComponent } from './user-billing-page/user-billing-page.component';
import { AdminTestPageComponent } from './admin-test-page/admin-test-page.component';
import { EditPlanDetailsPageComponent } from './edit-plan-details-page/edit-plan-details-page.component';
import { ActivePageComponent } from './active-page/active-page.component';


const routes: Routes = [
  { path: 'user/active', component: ActivePageComponent },
  { path: 'login', component: LoginPageComponent },
  { path: 'register', component: RegisterPageComponent },
  { path: 'password/forgot', component: ForgotPasswordPageComponent },
  { path: 'password/forgot/:email', component: ForgotPasswordPageComponent },
  { path: 'password/reset', component: ResetPasswordPageComponent },
  { path: 'home', component: DashboardPageComponent, canActivate: [AuthGuard] },
  { path: 'contacts', component: ContactListPageComponent, canActivate: [AuthGuard] },
  { path: 'contacts/:tag', component: ContactListPageComponent, canActivate: [AuthGuard] },
  { path: 'tasks', component: TaskListPageComponent, canActivate: [AuthGuard] },
  { path: 'tasks/new', component: EditTaskPageComponent, canActivate: [AuthGuard] },
  { path: 'tasks/edit/:id', component: EditTaskPageComponent, canActivate: [AuthGuard] },
  { path: 'tasks/view/:id', component: EditTaskPageComponent, canActivate: [AuthGuard] },
  { path: 'account', component: AccountPageComponent, canActivate: [AuthGuard] },
  { path: 'logs', component: LogPageComponent, canActivate: [AuthGuard] },
  { path: 'setup/pbiconnection', component: PbiConnectionPageComponent, canActivate: [AuthGuard] },
  { path: 'setup/password', component: PasswordPageComponent, canActivate: [AuthGuard] },
  { path: 'billing/manage', component: EditPlanDetailsPageComponent, canActivate: [AuthGuard] },
  { path: 'billing', component: UserBillingPageComponent, canActivate: [AuthGuard] },
  { path: 'admin/billing', component: AdminBillingPageComponent, canActivate: [AuthGuard] },
  { path: 'admin/test-page', component: AdminTestPageComponent },
  { path: '**', redirectTo: '/home'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: true }), HttpClientModule],
  providers: [AuthGuard, AuthenticationService],
  exports: [RouterModule]
})
export class AppRoutingModule { }
